import { getLabelFromKeyValue } from "@/ui-sdk/components/utils/common";
import { flattenObj } from "../tag-based-products";
import { Tags } from "@/sdk/types";
import { BACKEND_URL } from "../product-list";

const CloudfrontUrl = "https://d21xluao80us9l.cloudfront.net";

export async function handleDescriptionBadgesStatic(element: HTMLElement) {
  const id = window.location.pathname.split("/").at(-1);
  const productTags = await window.helium.datastore.getTags({
    id,
  });

  const { details } = await window.helium.datastore.getProduct({ id });
  if (details.vendor.toLowerCase() === "knickgasm") {
    return;
  }
  try {
    const response = dummyBadgesData;
    if (!response) {
      console.error(`HTTP error! status: ${response.status}`);
      return;
    }
    const badgesData = await getBadgeData(productTags);
    if (!badgesData) return;
    const flattenTags = flattenObj(productTags, { seperator: "." });
    const html = DescriptionBadgesStatic({
      badgesData: badgesData,
      productTags: flattenTags,
    });
    element.innerHTML = html;
  } catch (e) {
    console.error("Badge:Could not load description badges", e);
    return;
  }
}
interface DescriptionBadgesStaticProps {
  badgesData: DescriptionBadgesData | null;
  productTags: Record<string, any>;
}

interface DescriptionBadgesData {
  tags: string[];
  limit: number;
  icons: Record<string, string>;
  lebels: Record<string, Record<string, string>>;
}

export const DescriptionBadgesStatic = ({
  badgesData,
  productTags,
}: DescriptionBadgesStaticProps): string => {
  if (!badgesData || !productTags) {
    return "";
  }

  const getValue = (tagKey: string, value: string | string[]) => {
    try {
      console.log(tagKey, value, "xxxxxx");
      const obj = badgesData.labels[tagKey];
      function getTagsValue(value) {
        if (typeof obj === "object") {
          return obj[value] ?? getLabelFromKeyValue(tagKey, value);
        } else return getLabelFromKeyValue(tagKey, value);
      }
      return Array.isArray(value)
        ? value.map((value) => getTagsValue(value)).join(", ")
        : getTagsValue(value);
    } catch (e) {
      console.log(e);
      return false;
    }
  };
  const keysToDisplay = badgesData.tags
    .filter((tagKey) => productTags.hasOwnProperty(tagKey))
    .slice(0, badgesData.limit);

  const keyMap = [];
  const doneTagsKeys = {};
  if (!badgesData.tags[0].includes(".")) {
    Object.keys(productTags).forEach((key) => {
      badgesData.tags.map((tagKey) => {
        if (doneTagsKeys[tagKey]) return;
        if (key.includes(tagKey)) {
          if (typeof productTags[key] === "boolean") return;
          keyMap.push(key);
          doneTagsKeys[tagKey] = true;
        }
      });
    });
  } else {
    keyMap.push(...badgesData.tags);
  }
  let badgesToDisplay = keyMap
    .map((tagKey) => {
      let value: string = getValue(tagKey, productTags[tagKey]);
      if (typeof value !== "string") return {};
      if (typeof value === "string" && value.includes("None")) {
        value = value.replace("None", "Low").trim();
      }
      console.log({ value }, "xxxx");
      return {
        key: tagKey,
        text: tagKey.split("~").pop() || tagKey,
        value,
        icon: badgesData.icons[tagKey],
      };
    })
    .filter((badge) => badge.value);

  if (badgesToDisplay.length === 0) {
    return "";
  }

  if (badgesToDisplay.length % 2 === 1)
    badgesToDisplay = badgesToDisplay.slice(0, -1);
  let htmlString =
    '<div class="hp-my-4 hp-px-4"><h3 class="hp-heading">Product Highlights</h3><div class="hp-grid hp-grid-cols-2 hp-gap-6 hp-my-4 ">';
  badgesToDisplay.forEach((badge) => {
    const iconHtml = badge.icon
      ? `<img src="${badge.icon}" class="hp-h-5 hp-w-5"/>`
      : "";
    htmlString += `
      <div class="hp-flex hp-items-center hp-gap-4">
        ${iconHtml}
        <span class=" hp-font-normal hp-font-medium hp-text-xs"> ${badge.value}</span>
      </div>
    `;
  });
  htmlString += "</div></div>";
  return htmlString;
};
async function getBadgeData(tags: Tags) {
  const { category, subcategory } = tags;
  if (category.toLowerCase() === "footwear") return dummyBadgesData;
  else {
    return null;
    const res = await fetch(
      `${CloudfrontUrl}/global/${subcategory.toLowerCase()}/tiers.json`,
    );
    if (!res.ok) {
      throw new Error("Failed to fetch tiers data");
    }
    const tiers = await res.json();
    const obj = tiers[Object.keys(tiers)[0]];
    return {
      tags: [...obj["topAtrributes"], ...obj["awareness stage"]],
      limit: 6,
      icons: {},
      labels: {},
    };
  }
}
const icons = {
  "tags.visual.primary_material": `https://cdn.shopify.com/s/files/1/0795/9858/4101/files/logo_104d73f8-d51f-4847-a213-f88d78a72863.svg?v=1740722183`,
  "tags.visual.closure_type": `https://cdn.shopify.com/s/files/1/0795/9858/4101/files/logo_e92edbbf-7460-412d-9717-7ecc67d91134.svg?v=1740722202`,
  "tags.visual.pattern": `https://cdn.shopify.com/s/files/1/0795/9858/4101/files/logo_4bdcd958-4f18-44ab-ad6a-7881ea1ddd0b.svg?v=1740722212`,
  "tags.visual.sneaker_shape": `https://cdn.shopify.com/s/files/1/0795/9858/4101/files/logo_564b2331-494f-4aad-9911-2683d52520df.svg?v=1740722639`,
  "tags.visual.color.primary.value": `https://cdn.shopify.com/s/files/1/0795/9858/4101/files/logo_5a61e811-adba-483e-881f-cc224e0a9606.svg?v=1740722256`,
  "tags.visual.weight_class": `https://cdn.shopify.com/s/files/1/0795/9858/4101/files/logo_5280df03-cd77-4f6a-bb16-c553b1131a1b.svg?v=1740722446`,
};
const dummyBadgesData: BadgesData = {
  tags: [
    "tags.visual.primary_material",
    "tags.visual.closure_type",
    "tags.visual.sneaker_shape",
    "tags.visual.ankle_support",
    "tags.visual.silhouette",
    "tags.visual.pattern",
    "tags.visual.color.primary.value",
    "tags.visual.weight_class",
  ],
  limit: 6,
  icons: {
    ...icons,
    "tags.visual.ankle_support": icons["tags.visual.sneaker_shape"],
    "tags.visual.silhouette": `https://cdn.shopify.com/s/files/1/0795/9858/4101/files/image_2.png?v=1740746526`,
  },
  labels: {
    "tags.visual.ankle_support": {
      low: "Low Ankle",
      high: "High Ankle",
    },
    "tags.visual.primary_material": undefined,
    "tags.visual.closure_type": {
      "lace-up": "Lace Up",
    },
    "tags.visual.sneaker_shape": {
      "low-top": "Low Top",
      "high-top": "High Top",
    },
    "tags.visual.color.primary.value": {
      //black: "built Black",
      //white: "pure White",
      //red: "bright Red",
      //blue: "Blue",
      //green: "Green",
    },
    "tags.visual.weight_class": {
      Light: "Light Weight",
      Medium: "Medium Weight",
      Heavy: "Heavy Weight",
    },
  },
};
